export default __webpack_public_path__ + "static/media/connected.43649906.svg";